import React, { useState } from "react";
import cssClasses from "../NewFolderModal/NewFolderModal.module.css";
import { Box, Modal } from "@mui/material";
import Button from "../../../Subcomponents/Button";
import DateComponent from "../../../Subcomponents/DateComponent";

const CustomDateModal = ({ open, handleClose, submitHandler }) => {
  const [helperText, setHelperText] = useState({
    startDate: "",
    endDate: "",
  });
  const [selectDates, setSelectDates] = useState([
    { label: "StartDate", value: "" },
    { label: "EndDate", value: "" },
  ]);
  return (
    <Modal
      open={open}
      onClose={() => handleClose({ flag: false })}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(193, 201, 210, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper} style={{ width: "max-content" }}>
        <div className={cssClasses.header}>
          {/* <img src={MessageIcon} alt="" /> */}
          <h1>Select Date</h1>
        </div>
        <div className={cssClasses.mainContainer}>
          <Box className={cssClasses.listWrapper}>
            <div>
              <div className={cssClasses.dateTimeWrapper}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <DateComponent
                    minDate={"1 Jan"}
                    maxDate={new Date()}
                    value={selectDates[0].value}
                    helperText={helperText?.startDate}
                    onChangeDate={(value) => {
                      setSelectDates((pre) => {
                        pre[0].value = value;
                        return { ...pre };
                      });
                      setHelperText((pre) => {
                        pre.endDate = "";
                        return { ...pre };
                      });
                    }}
                  />
                  <span style={{ color: "rgba(102, 112, 133, 1)" }}>
                    Start Date
                  </span>
                </div>
                <span style={{ color: "rgba(102, 112, 133, 1)" }}> __</span>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <DateComponent
                    minDate={"1 Jan"}
                    value={selectDates[1].value}
                    helperText={helperText?.endDate}
                    onChangeDate={(value) => {
                      if (selectDates[0].value === "") {
                        setHelperText((pre) => {
                          pre.endDate = "Please select start date first";
                          return { ...pre };
                        });
                      } else {
                        if (selectDates[0].value > value) {
                          setHelperText((pre) => {
                            pre.endDate =
                              "Select End Date Greater than start Date";
                            return { ...pre };
                          });
                        } else {
                          setSelectDates((pre) => {
                            pre[1].value = value;
                            return { ...pre };
                          });
                          setHelperText((pre) => {
                            pre.endDate = "";
                            return { ...pre };
                          });
                        }
                      }
                    }}
                  />
                  <span style={{ color: "rgba(102, 112, 133, 1)" }}>
                    End Date
                  </span>
                </div>
              </div>
            </div>
          </Box>
        </div>

        <div className={cssClasses.footer}>
          {/* <div><Button style={{ color: "#7F56D9", backgroundColor: "#ffffff" }} btnName={"Download PDF"} clicked={handleClose} /></div> */}
          <div>
            <Button
              style={{ color: "#344054", backgroundColor: "#ffffff" }}
              btnName={"Cancel"}
              clicked={() => handleClose({ flag: false })}
            />
          </div>
          <div>
            <Button
              style={{ color: "#ffffff", backgroundColor: "#155EEF" }}
              btnName={"Next"}
              clicked={() => {
                submitHandler(selectDates);
              }}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default CustomDateModal;
